module.exports = __webpack_public_path__ + "img/benefit02.7a49b479.png";